import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export interface GetVersionResponse {
  version: string
};

export const getVersion = () => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.GET_PORTAL_VERSION_REQUEST });

  return api.app.portal.getVersion()
    .then((res: any) => {

      dispatch({
        type: types.GET_PORTAL_VERSION_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_PORTAL_VERSION_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getContact = () => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.GET_PORTAL_CONTACT_REQUEST });

  return api.app.portal.getContact()
    .then((res: any) => {

      dispatch({
        type: types.GET_PORTAL_CONTACT_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_PORTAL_CONTACT_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
